module.exports = __webpack_public_path__ + "media/reference1.34371618.mp3";